// eslint-disable-next-line boundaries/no-unknown-files -- Reason: App.tsx is the root entry point, configured in eslint.config.ts but pattern matching may not work correctly
import { CoreApp } from "@/domains/core";

/**
 * Einstiegspunkt für die React-Anwendung.
 * Bindet die App-Shell (`CoreApp`) ein, inklusive Router & Layout.
 *
 * @returns {JSX.Element} Die gerenderte CoreApp-Komponente
 *
 */
export function App() {
  return <CoreApp />;
}
